
import { initProfitCalculators } from "./../js/profitCalculators/initProfitCalculators.jsx";

initProfitCalculators("profit-calculator");
